import { render, staticRenderFns } from "./RoutingStatusSection.vue?vue&type=template&id=5f88edae&scoped=true&"
import script from "./RoutingStatusSection.vue?vue&type=script&lang=js&"
export * from "./RoutingStatusSection.vue?vue&type=script&lang=js&"
import style0 from "./RoutingStatusSection.vue?vue&type=style&index=0&id=5f88edae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88edae",
  null
  
)

export default component.exports